import { Divider } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { API } from '@/api'
import { ServerScaleMetricListInfo, ServerScaleSpecInfo } from '@/api/type-server.ts'
import { Loading, Trans } from '@/components'

interface ScalingSpecMonitorProp {
  scalingSpecResId: string
}

export default function ScalingSpecMonitor({ scalingSpecResId }: ScalingSpecMonitorProp) {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [metricList, setMetricList] = useState<ServerScaleMetricListInfo[]>([])
  const [scaleSpec, setScaleSpec] = useState<ServerScaleSpecInfo>()

  const getScaleSpec = useCallback(
    async (specId: string) => {
      setLoading(true)
      try {
        const res = await API.getScaleSpec({
          spec_id: specId,
        })
        if (res.code === 0) {
          setScaleSpec(res.spec)
        }
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    },
    [scalingSpecResId],
  )

  useEffect(() => {
    getScaleSpec(scalingSpecResId)
  }, [scalingSpecResId])

  const getMetricList = useCallback(
    async (specId: string) => {
      setLoading(true)
      try {
        const res = await API.getScaleMetricList({
          spec_id: specId,
        })
        if (res.code === 0) {
          setMetricList(res.matrix)
        }
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    },
    [scalingSpecResId],
  )

  useEffect(() => {
    getMetricList(scalingSpecResId)
  }, [scalingSpecResId])

  return (
    <>
      {loading && (
        <div className="w-full flex items-center justify-center p-8">
          <Loading />
        </div>
      )}
      {!loading && metricList.length > 0 && (
        <div className="bg-panel-gray-100 rounded-lg flex flex-wrap py-4 t-sm text-tertiary gap-y-4">
          <div className="w-full px-4">
            <div className="grid grid-cols-6 gap-x-4">
              {metricList.map((metric, index) => (
                <div key={index}>
                  <div className="t-sm text-secondary mb-1">{metric.name}</div>
                  <div className="t-xs text-primary">
                    {metric.matrixArray[metric.matrixArray.length - 1]?.matrix[1] || '-'}
                  </div>
                </div>
              ))}
            </div>
            <Divider className="mb-3 mt-4"></Divider>
            <div
              className="t-x-sb text-highlight cursor-pointer"
              onClick={() =>
                navigate('/scaling/monitor', {
                  state: {
                    scalingSpecId: scalingSpecResId,
                    scaleSpec,
                  },
                })
              }
            >
              <Trans i18nKey="scaling.monitor.viewDetailBtn">View Detail</Trans>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
